export default __webpack_public_path__ + "static/reward-cd96cf4b598665ef5785f74a3ffdc3f7.svg";